import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { getOptions } from '@recruitee/walkthrough-utils';

export interface MessagesCounters {
  textingSentMessagesCount: number;
  textingReceivedMessagesCount: number;
  textingMessagesCount: number;
  textingThreadsUnread: boolean;
  mailboxMessagesCount: number;
  mailboxThreadsUnread: boolean;
}

@Injectable({ providedIn: 'root' })
export class MessagesCountersHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public loadMessagesCounters(candidateId: number): Observable<MessagesCounters> {
    return this.httpApi
      .get(
        `/candidates/${candidateId}/messages_counters`,
        null,
        getOptions({ hasOnboarding: true }),
      )
      .pipe(map(data => data.messagesCounters));
  }
}
